import React from 'react';
import { createMachine } from 'xstate';
import { Model } from 'xstate/lib/model.types';
import { BaseContext, BaseEvent, customElement, remoteMessage } from '../../../machine';

import { ZoryveSavingProgramTerms } from '../ZoryveDirect.components';

const WELCOME = 'WELCOME';
const TERMS = 'TERMS';
const QUESTIONS = 'QUESTIONS';

export const TERMS_MESSAGES = {
  WELCOME: 'Please review the terms and condiitons by clicking the button below:',
  TERMS: <ZoryveSavingProgramTerms />,
  QUESTIONS: (
    <>
      Questions? Call{' '}
      <span>
        <a href="tel:1-844-979-1288" style={{ color: 'inherit' }}>
          <u>1-844-979-1288</u>
        </a>
      </span>{' '}
      from 6:00 am–5:00 pm PT, M–F. Text STOP to unsubscribe. Text TERMS for Terms and Conditions to
      1-440-496-7983.
    </>
  ),
};

/**
 * ZORYVE Direct Program Flow V2.0
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ZoryveDirectTermsFlow = (
  model: Model<BaseContext, BaseEvent, void>,
  initial = WELCOME
) =>
  createMachine<BaseContext, BaseEvent>({
    id: 'ZoryveDirectTermsFlow',
    initial: initial ?? WELCOME,
    context: model.initialContext,
    states: {
      [WELCOME]: remoteMessage({
        id: WELCOME,
        message: TERMS_MESSAGES.WELCOME,
        nextState: TERMS,
      }),

      [TERMS]: customElement({
        id: TERMS,
        jsx: TERMS_MESSAGES.TERMS,
        nextState: QUESTIONS,
      }),

      [QUESTIONS]: remoteMessage({
        id: QUESTIONS,
        message: TERMS_MESSAGES.QUESTIONS,
      }),
    },
  });
